import {CATALOG_TITLE} from 'modules/categories/constants';
import {CategorySeoPageContext} from 'modules/categories/context';
import {useCategoriesTree} from 'modules/categories/hooks/useCategoriesTree';
import {CategorySeoPage} from 'modules/categories/pages/CategorySeoPage';
import Head from 'next/head';
import React from 'react';

export const CategoryFirstLevelPageProvider = () => {
    const categoriesTree = useCategoriesTree();

    return (
        <>
            <Head>
                <title>{CATALOG_TITLE}</title>
            </Head>
            <CategorySeoPageContext.Provider value={{categoriesTree}}>
                <CategorySeoPage />
            </CategorySeoPageContext.Provider>
        </>
    );
};
